<template>
  <b-modal
    :id="`${serviceType}-online-drivers-without-trips`"
    title="Online Drivers"
  >
    <b-table
      responsive
      :fields="columns"
      :items="tableData"
    />

  </b-modal>
</template>

<script>
import { BTable, BModal } from 'bootstrap-vue'

export default {
  components: { BTable, BModal },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    serviceType: {
      type: String,
      default: undefined,
    },
  },
  setup(props) {
    const columns = ['zone', 'count']
    const tableData = props.data
    return {
      columns,
      tableData,
    }
  },

}
</script>

<style>

</style>
